import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  item: {
    position: "relative",
  },
  chart: {
    position: "absolute",
    right: 0,
    bottom: 0,
  },
};
